module.exports = __webpack_public_path__ + "static/media/upstate-sm.28cb5b8d.svg";